<template>
  <div class="select_slat_ctg">
    <ul class="slat_ctg__main">
      <set-slat-category
        as="li"
        :key="id"
        :ctgMap="{id, name}"
        :class="id"
        v-for="{id, name, imgId } in categorized.main"
      >
        <template #image>
          <img class="set_slat__image" :src="`assets/parts/category/${imgId || id}.jpg`" width="204" height="140" :alt="name" />
        </template>
        <img v-if='isSudare(id)' :src="require(`../../assets/img/parts/category/${id}.svg`)" width="84" height="10">
        <span v-else-if="isSeriesToki(id)" :class="id">
          {{  name.slice(5) }}
        </span>
        <span v-else>{{ name }}</span>
      </set-slat-category>
    </ul>
    <ul class="slat_ctg__sub"
      :class="{centered: categorized.sub.length < 3}"
      v-if="categorized.sub.length > 0"
    >
      <set-slat-category
        as="li"
        :key="id"
        :ctgMap="{id, name}"
        :class="id"
        class="no_ratio"
        v-for="{id, name} in categorized.sub"
      >
        {{ name }}
      </set-slat-category>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import SetSlatCategory from './parts/SetSlatCategory.vue'

const subCtg = ['無地', '遮光', 'レース']

export default {
  components: {
    SetSlatCategory
  },
  computed: {
    ...mapState('simulator', ['slat_category']),
    ...mapGetters('simulator', ['slat_ctg_by_product', 'is_slat_selected']),
    categorized () {
      return this.slat_ctg_by_product
        .reduce((result, ctg) => {
          result[subCtg.includes(ctg.name) ? 'sub' : 'main'].push(ctg)
          return result
        }, { main: [], sub: [] });
    }
  },
  methods: {
    ...mapMutations(['setModal']),
    ...mapActions('simulator', ['setSlatCtgSelected']),
    isSudare (id) {
      return id === 'sudare'
    },
    isSeriesToki (id) {
      return id.startsWith('toki-')
    },
  },
  mounted () {
    if (this.is_slat_selected) {
      this.setModal('BrowseSlatByCtg')
    }
  },
  updated () {
    if (this.is_slat_selected) {
      this.setModal('BrowseSlatByCtg')
    }
  }
}
</script>

<style lang="scss" scoped>
    .select_slat_ctg {
    display: flex;
    flex-flow: row nowrap;
    height: 100%;
    [class^=slat_ctg] {
      margin: 0;
      padding: 0;
      > * {
        list-style: none;
      }
    }
    .slat_ctg__main {
      flex: 1 0 auto;
      flex-basis: calc(256 / 329 * 100%);
      height: 100%;
      overflow-y: auto;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      align-items: flex-start;
      .set_slat_ctg {
        flex: 0 0 auto;
        flex-basis: calc(122 / 256 * 100%);
      }
      .set_slat_ctg:last-child,
      .set_slat_ctg:nth-last-of-type(n+2){
        margin-bottom: calc(10 / 256 * 100%);
      }
    }
    .slat_ctg__sub {
      flex: 0 1 auto;
      flex-basis: calc((329 - 256) / 329 * 100%);
      margin-left: calc(12 / 329 * 100%);
      display: flex;
      flex-flow: column nowrap;
      justify-content: space-between;
      height: 100%;
      .set_slat_ctg {
        flex: 0 0 auto;
        flex-basis: calc(33.33333% - (12 / 216 * 100%));
      }
      &.centered {
        justify-content: center;
        .set_slat_ctg {
          margin: calc(12 / 216 * 3 * 100%) 0;
        }
      }
    }
  }
</style>